import { gql } from '@apollo/client';

export const UnlockParkingByIdMutation = gql`
  mutation UnlockParkingById($parkingId: ID!, $type: String!, $gate: String) {
    unlock(parkingId: $parkingId, type: $type, gate: $gate) {
      id
      parking {
        id
      }
      gate {
        id
      }
    }
  }
`;
